module.exports = __webpack_public_path__ + "img/pic_map_shopHengDa.a16a3943.png";